import React from 'react';
import { createRoot } from 'react-dom/client';  // Import from react-dom/client
import * as Sentry from '@sentry/react';
import App from './containers/App/App';
import { scrubEvent } from './sentry/eventScrubber';
import * as serviceWorker from './serviceWorker';

// Sentry init must run before React renders so early render errors get
// captured. Leaving the DSN empty (local dev) makes the SDK a no-op.
// See `~/.claude-specs/incentco/ICOV3/ICOV3-1386-specs.md`.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || undefined,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'local',
  sendDefaultPii: false,
  beforeSend: scrubEvent,
  // Noise filter — matches the API-side ignore_exceptions list.
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
  ],
});

const rootElement = document.getElementById('root');

const root = createRoot(rootElement);

root.render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: 24, textAlign: 'center' }}>
        <h2>Something went wrong.</h2>
        <p>Our team has been notified. Please refresh the page to try again.</p>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
